import { API_REFERENCE } from '../utilities/constant_api';
import { jsonPost } from '../components/ajax';
import * as constantConfig from '../utilities/constant_config';
import { numbersOnly } from '../utilities/utility';

const clsSupplyOnHandContainer = '.checkout-supply-on-hand';
const clsNextEligibleDate = `${clsSupplyOnHandContainer}__date`;
const clsProductRow = '.shipping-error';
const clsSupplyOnHandEntry = '.supplydayasonHand__input';
const entryNumber = 'data-entry-number';
const productCode = 'data-product-code';
const dataPrevValue = 'data-prev';
const dataAction = 'data-action';
const dataAdjustmentRequired = 'data-adjustmentRequired';
const clsSupplyOnHandNextBtn = '.checkout-supply-on-hand__next';
const clsSupplyOnHandRemoveBtn = '.checkout-supply-on-hand__remove';
const clsHiddenRemovalEntry = '.checkout-supply-on-hand__removalEntry';
const clsShippingError = '.shipping-error';
const supplyOnHandFormId = '#daysSupplyOnHandForm';
const clsEligibleDatePushedMsg = '.extendeddateerrormessage';
const clsSupplyOnHandCont = '.supplydayasonHand__container';
const strHidden = 'hidden';

const $productRowDetails = $(`${clsSupplyOnHandContainer} ${clsProductRow}`);
const removeItemUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.checkoutActionItems.removeItem}`;
const nextEligibleShipDateUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.checkoutActionItems.calculateNextEligibleShipDate}`;
const resolveSupplyOnHandUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.checkoutActionItems.resolveSupplyOnHand}`;
let nextStepButtonAction = false;
const checkoutSupplyOnHand = {
  payloadCreation() {
    const payloadData = {
      chhCheckoutValidationData: {
        errorDetails: []
      }
    };
    const errorDetailsArray = [];
    $productRowDetails.each((i, obj) => {
      const productRow = {
        entryNumber: '',
        daysSupplyOnHand: '',
        product: {
          code: ''
        }
      };
      productRow.entryNumber = parseInt($(obj).attr(entryNumber), 10);
      productRow.daysSupplyOnHand = $(obj)
        .find(clsSupplyOnHandEntry)
        .val();
      productRow.product.code = $(obj).attr(productCode);
      errorDetailsArray.push(productRow);
    });
    payloadData.chhCheckoutValidationData.errorDetails = errorDetailsArray;
    return payloadData;
  },
  onInputDaysOnHand(e) {
    const code = e.keyCode ? e.keyCode : e.which;
    if (code === 13) {
      e.preventDefault();
      $(`${clsSupplyOnHandContainer} ${clsSupplyOnHandEntry}`).blur();
    }
  },
  populateForm(action, thisObj, formParent) {
    const removalEntry = $(thisObj)
      .parents(clsShippingError)
      .attr(entryNumber);
    formParent.attr('action', resolveSupplyOnHandUrl);
    if (action === 'remove') {
      formParent.find(clsHiddenRemovalEntry).val(removalEntry);
      formParent.attr('action', removeItemUrl);
    }
  },
  submitSupplyOnHandForm() {
    const thisObj = $(this);
    const formParent = thisObj.parents(supplyOnHandFormId);

    const action = thisObj.attr(dataAction);
    if(!nextStepButtonAction){
      nextStepButtonAction = true;
      checkoutSupplyOnHand.populateForm(action, thisObj, formParent);
      formParent.submit();
    }
  },

  getNextEligibleShipDate(thisObj) {
    const parentObj = $(thisObj).parents(clsSupplyOnHandContainer);
    const payload = JSON.stringify(checkoutSupplyOnHand.payloadCreation());
    parentObj.find(clsEligibleDatePushedMsg).addClass(strHidden);
    $('.global-error-message-container').addClass('hidden');
    jsonPost(nextEligibleShipDateUrl, payload).then(response => {
      const responseData = response !== '' ? JSON.parse(response) : {};
      if (responseData.status === constantConfig.SUCCESS) {
        parentObj
          .find(clsNextEligibleDate)
          .html(`[${responseData.nextEligibleShipDate}]`);
        let maxSupplyOnHand = 10;
        $(`${clsSupplyOnHandContainer} ${clsSupplyOnHandEntry}`).each(function(
          index,
          obj
        ) {
          const objVal = parseInt($(obj).val(), 10);
          if (objVal > maxSupplyOnHand) {
            maxSupplyOnHand = objVal;
          }
        });
        $(`${clsSupplyOnHandContainer} ${clsSupplyOnHandEntry}`).each(function(
          index,
          obj
        ) {
          const thisParent = $(obj).parents(clsSupplyOnHandCont);
          const objValue = parseInt($(obj).val(), 10);
          if (objValue === maxSupplyOnHand) {
            thisParent
              .siblings(clsEligibleDatePushedMsg)
              .removeClass(strHidden);
          }
        });
        thisObj.attr(dataPrevValue, thisObj.val());
      } else if (responseData.status === constantConfig.ERROR) {
        $('.global-error-message-container')
          .removeClass('hidden')
          .find('.generic-error-text')
          .text(responseData.errorMessage);
        window.scrollTo(0, 0);
      }
    });
  },
  enableDisableContinueButton() {
    let disableButton = false;
    $(`${clsSupplyOnHandContainer} ${clsSupplyOnHandEntry}`).each(function(
      index,
      obj
    ) {
      const { valueMissing } = obj.validity;
      if (valueMissing) {
        disableButton = valueMissing;
      }
    });
    $(`${clsSupplyOnHandContainer} ${clsSupplyOnHandNextBtn}`).attr(
      'disabled',
      disableButton
    );
  },
  obtainNextEligibleShipDate(e) {
    // replace with previous validated value if no value present
    const thisObj = $(this);
    const previousValue = thisObj.attr(dataPrevValue);
    const { valueMissing } = e.target.validity;
    if (valueMissing) {
      thisObj.val(previousValue);
      return true;
    }
    // get the next eligible ship date
    checkoutSupplyOnHand.getNextEligibleShipDate(thisObj);
    return true;
  },
  init() {
    const adjustmentRequired = $(clsSupplyOnHandContainer).attr(
      dataAdjustmentRequired
    );

    $(`${clsSupplyOnHandContainer} ${clsSupplyOnHandEntry}`).on(
      'keypress',
      numbersOnly
    );
    if (adjustmentRequired === 'true') {
      $(`${clsSupplyOnHandContainer} ${clsSupplyOnHandEntry}`).on(
        'blur',
        checkoutSupplyOnHand.obtainNextEligibleShipDate
      );
    } else {
      $(`${clsSupplyOnHandContainer} ${clsSupplyOnHandEntry}`).on(
        'input',
        checkoutSupplyOnHand.enableDisableContinueButton
      );
    }
    $(`${clsSupplyOnHandContainer} ${clsSupplyOnHandEntry}`).on(
      'keypress',
      checkoutSupplyOnHand.onInputDaysOnHand
    );
    $(
      `${clsSupplyOnHandContainer} ${clsSupplyOnHandNextBtn},${clsSupplyOnHandContainer} ${clsSupplyOnHandRemoveBtn}`
    ).on('click', checkoutSupplyOnHand.submitSupplyOnHandForm);
  }
};
checkoutSupplyOnHand.init();

export default checkoutSupplyOnHand;
